import { TilesetDefinitionAPI } from "src/engine/level/LevelLoaderAPI";

import adveTiles16Image from "../tiled/tilesets/adve/tiles16.png";
import adveTiles16TileSet from "../tiled/tilesets/adve/tiles16.tsj";
import backCaveImage from "../tiled/tilesets/caves/back-cave-tiles.png";
import backCaveTileset from "../tiled/tilesets/caves/back-cave-tiles.tsj";
import backCranesImage from "../tiled/tilesets/caves/back-cranes.png";
import backCranesTileset from "../tiled/tilesets/caves/back-cranes.tsj";
import backCrystalcaveImage from "../tiled/tilesets/caves/back-crystalcave-tiles.png";
import backCrystalcaveTileset from "../tiled/tilesets/caves/back-crystalcave-tiles.tsj";
import crystalcaveImage from "../tiled/tilesets/caves/crystalcave-tileset.png";
import crystalcaveTileset from "../tiled/tilesets/caves/crystalcave-tileset.tsj";
import frontStalactitesImage from "../tiled/tilesets/caves/front-stalactites.png";
import frontStalactitesTileset from "../tiled/tilesets/caves/front-stalactites.tsj";
import insideCaveBuildingImage from "../tiled/tilesets/caves/inside-cave-building.png";
import insideCaveBuildingTileset from "../tiled/tilesets/caves/inside-cave-building.tsj";
import laddersImage from "../tiled/tilesets/caves/ladders.png";
import laddersTileset from "../tiled/tilesets/caves/ladders.tsj";
import mineImage from "../tiled/tilesets/caves/mine-tileset.png";
import mineTileset from "../tiled/tilesets/caves/mine-tileset.tsj";
import minecartsImage from "../tiled/tilesets/caves/minecarts.png";
import minecartsTileset from "../tiled/tilesets/caves/minecarts.tsj";
import rockSilhouettesImage from "../tiled/tilesets/caves/rock-silhouettes.png";
import rockSilhouettesTileset from "../tiled/tilesets/caves/rock-silhouettes.tsj";
import stalactitesImage from "../tiled/tilesets/caves/stalactites.png";
import stalactitesTileset from "../tiled/tilesets/caves/stalactites.tsj";
import underwaterDebrisImage from "../tiled/tilesets/caves/underwater-debris.png";
import underwaterDebrisTileset from "../tiled/tilesets/caves/underwater-debris.tsj";
import cryolabGroundImage from "../tiled/tilesets/cryo/cryolab-ground-tiles.png";
import cryolabGroundTileset from "../tiled/tilesets/cryo/cryolab-ground-tiles.tsj";
import cryolabHandRailsImage from "../tiled/tilesets/cryo/cryolab-hand-rails.png";
import cryolabHandRailsTileset from "../tiled/tilesets/cryo/cryolab-hand-rails.tsj";
import devPng from "../tiled/tilesets/dev/dev-tiles.png";
import devTileset from "../tiled/tilesets/dev/dev-tiles.tsj";
import devsetLargeImage from "../tiled/tilesets/dev/devset-large.png";
import defsetLargeSet from "../tiled/tilesets/dev/devset-large.tsj";
import bgDreamImage from "../tiled/tilesets/dream/bg-dream.png";
import bgDreamTileset from "../tiled/tilesets/dream/bg-dream.tsj";
import bgLightsDreamImage from "../tiled/tilesets/dream/bg-lights-dream.png";
import bgLightsDreamTileset from "../tiled/tilesets/dream/bg-lights-dream.tsj";
import bgPanelsDreamImage from "../tiled/tilesets/dream/bg-panels.png";
import bgPanelsDreamTileset from "../tiled/tilesets/dream/bg-panels.tsj";
import forest2tilesetimage from "../tiled/tilesets/forest/Forest2.png";
import forest2tileset from "../tiled/tilesets/forest/Forest2.tsj";
import Newforestfloorimage from "../tiled/tilesets/forest/Newforestfloor.png";
import NewforestfloorTileset from "../tiled/tilesets/forest/Newforestfloor.tsj";
import ForestGroundImage from "../tiled/tilesets/forest/forest-ground-tileset.png";
import ForestGroundTileset from "../tiled/tilesets/forest/forest-ground-tileset.tsj";
import forestTilesetImage from "../tiled/tilesets/forest/forest-tileset.png";
import forestTilesetTileSet from "../tiled/tilesets/forest/forest-tileset.tsj";
import ForesttilesetAimage from "../tiled/tilesets/forest/forest-tilesetA.png";
import ForesttilesetATileset from "../tiled/tilesets/forest/forest-tilesetA.tsj";
import sseWorlds1Image from "../tiled/tilesets/forest/sseworlds-1/_PNG/MainLevBuild.png";
import sseWorlds1TileSet from "../tiled/tilesets/forest/sseworlds-1/sseworlds-1.tsj";
import waterImage from "../tiled/tilesets/general/water-tileset.png";
import waterTileset from "../tiled/tilesets/general/water-tileset.tsj";
import mushroomPng from "../tiled/tilesets/mushrooms/mushroom_tileset.png";
import mushroomSet from "../tiled/tilesets/mushrooms/mushroom_tileset.tsj";
import Doxistesttilesimage from "../tiled/tilesets/old/doxistesttiles.png";
import Doxistesttilestileset from "../tiled/tilesets/old/doxistesttiles.tsj";
import modifiersPng from "../tiled/tilesets/shared/modifiers.png";
import modifiersTsj from "../tiled/tilesets/shared/modifiers.tsj";
import shrineBackgroundTilesPng from "../tiled/tilesets/shrine/shrine-background-tiles.png";
import shrineBackgroundTilesTileSet from "../tiled/tilesets/shrine/shrine-background-tiles.tsj";
import shrinePlatforms1Image from "../tiled/tilesets/shrine/shrine-platforms-1.png";
import shrinePlatforms1TileSet from "../tiled/tilesets/shrine/shrine-platforms-1.tsj";
import shrineImage from "../tiled/tilesets/shrine/shrine-tileset.png";
import shrineTileset from "../tiled/tilesets/shrine/shrine-tileset.tsj";
import beeLabPng from "../tiled/tilesets/tech/bee_lab.png";
import beeLabSet from "../tiled/tilesets/tech/bee_lab.tsj";
import insideCaveBuildingPng from "../tiled/tilesets/tech/inside_cave_building.png";
import insideCaveBuildingSet from "../tiled/tilesets/tech/inside_cave_building.tsj";
import labTilesCloseUpPng from "../tiled/tilesets/tech/lab_rooms_tiles_close_up.png";
import labTilesCloseUpTsj from "../tiled/tilesets/tech/lab_tiles_close_up.tsj";
import vp2InteriorsImage from "../tiled/tilesets/village/ssw-worlds/VP2_Interiors.png";
import vp2MainImage from "../tiled/tilesets/village/ssw-worlds/VP2_Main.png";
import vp2InteriorsTileSet from "../tiled/tilesets/village/ssw-worlds/vp2Interiors.tsj";
import vp2MainTileSet from "../tiled/tilesets/village/ssw-worlds/vp2main.tsj";
import villageExteriorsImage from "../tiled/tilesets/village/village-exteriors-1.png";
import villageExteriorsSet from "../tiled/tilesets/village/village-exteriors-1.tsj";

type TilesetEntry = {
  def: TilesetDefinitionAPI;
  /** Relative path from tilesets/ dir, without .tsj extension (e.g. "adve/tiles16") */
  filename: string;
};

export class TilesetRegistry {
  private _entries: Record<string, TilesetEntry> = {};
  private _record: Record<string, TilesetDefinitionAPI> | null = null;

  register(alias: string, def: TilesetDefinitionAPI, filename: string): void {
    this._entries[alias] = { def, filename };
    this._record = null; // invalidate cache
  }

  get(name: string): TilesetDefinitionAPI | undefined {
    return this._entries[name]?.def;
  }

  getFilename(alias: string): string {
    return this._entries[alias]?.filename ?? alias;
  }

  keys(): string[] {
    return Object.keys(this._entries);
  }

  allEntries(): [string, TilesetDefinitionAPI][] {
    return Object.entries(this._entries).map(([k, v]) => [k, v.def]);
  }

  /** Returns a plain Record for backward compatibility (e.g. GenericHotLoader). */
  asRecord(): Record<string, TilesetDefinitionAPI> {
    if (!this._record) {
      this._record = {};
      for (const [key, entry] of Object.entries(this._entries)) {
        this._record[key] = entry.def;
      }
    }
    return this._record;
  }
}

export const allTilesetsRegistry = new TilesetRegistry();

// Register all tilesets with their alias and real filename path
function r(
  alias: string,
  tileSetJson: any,
  tileSetImage: string,
  filename: string
) {
  allTilesetsRegistry.register(alias, { tileSetJson, tileSetImage }, filename);
}

r("tiles16", adveTiles16TileSet, adveTiles16Image, "adve/tiles16");
r(
  "forest-tileset",
  forestTilesetTileSet,
  forestTilesetImage,
  "forest/forest-tileset"
);
r(
  "vp2Interiors",
  vp2InteriorsTileSet,
  vp2InteriorsImage,
  "village/ssw-worlds/vp2Interiors"
);
r("vp2main", vp2MainTileSet, vp2MainImage, "village/ssw-worlds/vp2main");
r(
  "sseworlds-1",
  sseWorlds1TileSet,
  sseWorlds1Image,
  "forest/sseworlds-1/sseworlds-1"
);
r(
  "village-exteriors-1",
  villageExteriorsSet,
  villageExteriorsImage,
  "village/village-exteriors-1"
);
r(
  "cryolab-ground-tiles",
  cryolabGroundTileset,
  cryolabGroundImage,
  "cryo/cryolab-ground-tiles"
);
r(
  "cryolab-hand-rails",
  cryolabHandRailsTileset,
  cryolabHandRailsImage,
  "cryo/cryolab-hand-rails"
);
r(
  "shrine-platforms-1",
  shrinePlatforms1TileSet,
  shrinePlatforms1Image,
  "shrine/shrine-platforms-1"
);
r(
  "forest-tilesetA",
  ForesttilesetATileset,
  ForesttilesetAimage,
  "forest/forest-tilesetA"
);
r(
  "Newforestfloor",
  NewforestfloorTileset,
  Newforestfloorimage,
  "forest/Newforestfloor"
);
r(
  "forest-ground-tileset",
  ForestGroundTileset,
  ForestGroundImage,
  "forest/forest-ground-tileset"
);
r("shrine-tileset", shrineTileset, shrineImage, "shrine/shrine-tileset");
r(
  "doxistesttiles",
  Doxistesttilestileset,
  Doxistesttilesimage,
  "old/doxistesttiles"
);
r(
  "shrine-background-tiles",
  shrineBackgroundTilesTileSet,
  shrineBackgroundTilesPng,
  "shrine/shrine-background-tiles"
);
r("water-tileset", waterTileset, waterImage, "general/water-tileset");
r("Forest2", forest2tileset, forest2tilesetimage, "forest/Forest2");
r("bg-dream", bgDreamTileset, bgDreamImage, "dream/bg-dream");
r(
  "bg-lights-dream",
  bgLightsDreamTileset,
  bgLightsDreamImage,
  "dream/bg-lights-dream"
);
r("bg-panels", bgPanelsDreamTileset, bgPanelsDreamImage, "dream/bg-panels");
r("dev-tiles", devTileset, devPng, "dev/dev-tiles");
r("devset-large", defsetLargeSet, devsetLargeImage, "dev/devset-large");
r("back-cave-tiles", backCaveTileset, backCaveImage, "caves/back-cave-tiles");
r("back-cranes", backCranesTileset, backCranesImage, "caves/back-cranes");
r(
  "back-crystalcave-tiles",
  backCrystalcaveTileset,
  backCrystalcaveImage,
  "caves/back-crystalcave-tiles"
);
r(
  "crystalcave-tileset",
  crystalcaveTileset,
  crystalcaveImage,
  "caves/crystalcave-tileset"
);
r(
  "front-stalactites",
  frontStalactitesTileset,
  frontStalactitesImage,
  "caves/front-stalactites"
);
r("stalactites", stalactitesTileset, stalactitesImage, "caves/stalactites");
r("ladders", laddersTileset, laddersImage, "caves/ladders");
r("mine-tileset", mineTileset, mineImage, "caves/mine-tileset");
r("minecarts", minecartsTileset, minecartsImage, "caves/minecarts");
r(
  "inside-cave-building",
  insideCaveBuildingTileset,
  insideCaveBuildingImage,
  "caves/inside-cave-building"
);
r(
  "rock-silhouettes",
  rockSilhouettesTileset,
  rockSilhouettesImage,
  "caves/rock-silhouettes"
);
r(
  "underwater-debris",
  underwaterDebrisTileset,
  underwaterDebrisImage,
  "caves/underwater-debris"
);
r("bee_lab", beeLabSet, beeLabPng, "tilesets/bee_lab");
r(
  "inside_cave_building",
  insideCaveBuildingSet,
  insideCaveBuildingPng,
  "tilesets/inside_cave_building"
);
r(
  "lab_tiles_close_up",
  labTilesCloseUpTsj,
  labTilesCloseUpPng,
  "tilesets/lab_tiles_close_up"
);
r("modifiers", modifiersTsj, modifiersPng, "tilesets/shared/modifiers");
r("mushroom_tileset", mushroomSet, mushroomPng, "mushroom/mushroom_tileset");

/**
 * Backward-compatible plain Record export.
 * Existing code that does `allTilesets[key]` or `Object.entries(allTilesets)` continues to work.
 */
export const allTilesets: Record<string, TilesetDefinitionAPI> =
  allTilesetsRegistry.asRecord();
